var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedeem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 24.1001C11 22.4432 12.3431 21.1001 14 21.1001H36C37.6569 21.1001 39 22.4432 39 24.1001V25.3001H11V24.1001Z",
    stroke: "#F1BF70",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3999 25.2998H37.5999V34.1998C37.5999 35.8567 36.2568 37.1998 34.5999 37.1998H15.3999C13.743 37.1998 12.3999 35.8567 12.3999 34.1998V25.2998Z",
    stroke: "#F1BF70",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2999 20.4V16.2C24.2999 13.8804 22.4195 12 20.0999 12C17.7803 12 15.8999 13.8804 15.8999 16.2C15.8999 18.5196 17.7803 20.4 20.0999 20.4H24.2999Z",
    stroke: "#F1BF70",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7001 20.4V16.2C25.7001 13.8804 27.5805 12 29.9001 12C32.2197 12 34.1001 13.8804 34.1001 16.2C34.1001 18.5196 32.2197 20.4 29.9001 20.4H25.7001Z",
    stroke: "#F1BF70",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.6001,
    y: 21.1001,
    width: 2.8,
    height: 16.1,
    fill: "#F1BF70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeem);
export default __webpack_public_path__ + "static/media/redeem.d6dd8b69974446279cfb12ebce78b9df.svg";
export { ForwardRef as ReactComponent };